document.addEventListener("DOMContentLoaded", function () {
  const dropdown = document.getElementById("customShowroomDropdown");
  const selected = dropdown.querySelector(".selected");
  const options = dropdown.querySelector(".options");
  const optionItems = dropdown.querySelectorAll(".option");

  dropdown.addEventListener("click", function (e) {
    dropdown.classList.toggle("open");
    const currentSelection = selected.textContent.trim();

    options.querySelectorAll(".option").forEach(option => {
      if (option.textContent.trim() === currentSelection) {
        option.style.display = "none";
      } else {
        option.style.display = "block";
      }
    });
    e.stopPropagation();
  });

  document.addEventListener("click", () => {
    dropdown.classList.remove("open");
  });

  optionItems.forEach(option => {
    option.addEventListener("click", () => {
      const targetId = option.getAttribute("data-target");
      const blockId = targetId.replace("showroom-", "");

      selected.textContent = option.textContent;

      document.querySelectorAll(".showroom__content").forEach(el => el.style.display = "none");
      document.getElementById(targetId).style.display = "block";

      document.querySelectorAll(".showroom-image").forEach(el => el.style.display = "none");
      document.getElementById("showroom-image-" + blockId).style.display = "block";

      setTimeout(() => {
        dropdown.classList.remove("open");
      }, 10);
    });
  });
});
